import { FiltersMap } from '../model';
import { CollectionState } from './CollectionState';
import { action, computed, makeObservable } from 'mobx';

export interface PaginationModeCursorParams<
  T,
  F extends FiltersMap = FiltersMap,
> {
  collection: CollectionState<T, F>;
}

export class PaginationModeCursor<T, F extends FiltersMap = FiltersMap> {
  static readonly id = 'cursor' as const;

  readonly collection: CollectionState<T, F>;

  constructor(params: PaginationModeCursorParams<T, F>) {
    this.collection = params.collection;
    makeObservable(this, {
      fetchedLastPage: computed,
      setCursor: action,
    });
  }

  get fetchedLastPage() {
    const {
      query: {
        pagination: { cursor },
      },
    } = this.collection;
    return cursor == null;
  }

  setCursor(cursor: string | null) {
    const { query } = this.collection;
    query.pagination.cursor = cursor;
  }

  get id() {
    return PaginationModeCursor.id;
  }
}
